import React, { Fragment } from 'react';
import { Flex, Box, Image, Text } from 'rebass/styled-components';
import styled from 'styled-components';
import { Link } from 'gatsby';

import LupusCornerLogo from '../../assets/images/lupuscorner-logo.svg';
import iconFB from '../../assets/images/icon-fb.png';
import iconTW from '../../assets/images/icon-tw.png';
import iconIG from '../../assets/images/icon-ig.png';

const StyledLink = styled(Link)`
  font-size: 14px;
  font-weight: 600;
  color: #8356be;
  text-decoration: none;
  margin: 4px 0px;

  &:hover {
    color: ${({ theme }) => theme.colors.primaryLight};
  }
  &:active {
    color: ${({ theme }) => theme.colors.primaryDark};
  }
  transition: 0.3s;
`;

const SocialLink = styled.a`
  margin-right: 22px;
`;

const UnstyledLink = styled.a`
  text-decoration: none;
  color: inherit;
  &:hover {
    color: ${({ theme }) => theme.colors.primaryLight};
  }
`;

const Footer = () => (
  <Fragment>
    <Box width="100%" height="1px" bg="#E1E1E1"></Box>
    <Flex flexDirection="column" mx={[4, 5]} py={5}>
      <Link to="/">
        <Image src={LupusCornerLogo} width={'120px'} mb={1}></Image>
      </Link>
      <Flex my={2}>
        <SocialLink href="https://facebook.com/mylupuscorner">
          <Image src={iconFB} width={'28px'}></Image>
        </SocialLink>
        <SocialLink href="https://twitter.com/lupuscorner">
          <Image src={iconTW} width={'28px'}></Image>
        </SocialLink>
        <SocialLink href="https://www.instagram.com/mylupuscorner/">
          <Image src={iconIG} width={'28px'}></Image>
        </SocialLink>
      </Flex>
      <StyledLink to="/privacy-policy">Privacy Policy</StyledLink>
      <StyledLink to="/terms-conditions">Terms & Conditions</StyledLink>
      <Text fontSize={1} fontWeight={500} my={1}>
        © 2020{' '}
        <UnstyledLink href="https://www.progentec.com/">
          Progentec Diagnostics, Inc.
        </UnstyledLink>
      </Text>
    </Flex>
  </Fragment>
);

export default Footer;
